module.exports = __webpack_public_path__ + "img/41f1592.png";